import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import { SampleQueries } from './IllustrativeContent';

/**
 * Suggestions Block Component
 */
const Suggestions = ({ illustrative = false, maxSuggestions, maxItems = 5, hidden, ...props }) => {
  if (hidden) return null;
  if (illustrative) return <SampleQueries kind="suggestions" maxItems={maxSuggestions || maxItems} />;

  const maxToShow = maxSuggestions || maxItems;
  // Deterministic width formula
  const getWidth = (i) => 70 + ((i * 19) % 50);

  return (
    <Box display="flex" flexDirection="column" gap={1} {...props}>
      <Typography variant="caption" style={{ color: '#9e9e9e', fontWeight: 600, paddingLeft: 4 }}>
        <IntlMessages id="ui.searchExperienceV2.core.blocks.suggestions.suggestions" />
      </Typography>

      <Box display="flex" flexDirection="column" gap={0.5}>
        {Array.from({ length: maxToShow }).map((_, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`suggestion-${i}`}
            px={1.5}
            py={1}
            display="flex"
            alignItems="center"
            gap={1}
          >
            <Box width={14} height={14} bgcolor="#f5f5f5" borderRadius="50%" style={{ opacity: 0.5 }} />
            <Box width={getWidth(i)} height={8} bgcolor="#eeeeee" borderRadius={4} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Suggestions;
